<div class="h-16">
  <div class="fixed top-0 z-50 h-16 w-full bg-primary-prune p-6 text-white">
    <div class="container mx-auto h-full">
      <div class="flex h-full items-center">
        <div class="font-semibold md:text-xl">{{title}}</div>
        <div class="ml-auto">
          <pax-uncontrolled-select
            id="language-select"
            [options]="acceptedLanguages"
            [selectedValue]="initialLanguage"
            (changedSelection)="setLanguage($event)"
          />
        </div>
        <a class="ml-8" href="https://www.pax.ch">
          <img
            src="./assets/images/pax-logo-dark.svg"
            alt="Pax Logo"
            class="w-16 md:w-20"
          />
        </a>
      </div>
    </div>
  </div>
</div>
